const handleClickDeleteChecklistModalEquipService = {
  confirm: 'Do you really want to delete the complete checklist for this site?',
  title: 'DELETE CHECKLIST'
}

export default handleClickDeleteChecklistModalEquipService;
